import { DeviceDetailState } from './interface';

export const initialState: DeviceDetailState = {
  deviceData: {
    data: null,
    status: null,
  },
  newDevice: null,
  generalData: {
    data: null,
    status: null,
  },
  historicUsers: {
    data: [],
    status: null,
    pagination: {
      page: 0,
      total: 0,
    },
  },
  notes: {
    data: [],
    status: null,
    pagination: {
      page: 0,
      total: 0,
    },
  },
  statusData: {
    data: null,
    status: null,
  },
  statusGraphsData: {
    data: null,
    status: null,
    total: 0,
  },
  statusHistory: {
    items: [],
    total: 0,
    page: 0,
    size: 50,
    fromDate: null,
    toDate: null,
    status: null,
  },
  selectedHistoric: {
    historicId: null,
    data: null,
    status: null,
  },
  deviceActionData: {
    data: [],
    status: null,
    filterableValues: {},
    pagination: {
      pageDevice: 1,
      totalDevice: 0,
    },
  },
  devicePeripheralActionData: {
    data: [],
    status: null,
    filterableValues: {},
    pagination: {
      pageDevicePeripheral: 1,
      totalDevicePeripheral: 0,
    },
  },
  refreshStatus: false,
  commandSentErrorCode: 0
};
